import { useEffect, useState } from "react";

const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

export const Countdown = ({ endsAt, size = "md" }) => {
  const [left, setLeft] = useState(0);

  useEffect(() => {
    const tick = () => setLeft(new Date(endsAt) - Date.now());
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [endsAt]);

  const h = Math.floor(left / 3600000);
  const m = Math.floor((left % 3600000) / 60000);
  const s = Math.floor((left % 60000) / 1000);
  const cls = size === "lg" ? "text-3xl sm:text-4xl" : "text-lg";

  return (
    <div data-testid="deal-countdown" className={`font-display ${cls} tabular-nums flex items-baseline gap-1`}>
      <span className="text-[#FFCC00]">{pad(h)}</span><span className="text-white/40 text-sm">H</span>
      <span className="text-[#FFCC00]">{pad(m)}</span><span className="text-white/40 text-sm">M</span>
      <span className="text-[#FF3B30]">{pad(s)}</span><span className="text-white/40 text-sm">S</span>
    </div>
  );
};
